<script setup lang="ts">
import IconProductTechnologySoftware from "../../../assets/icons/icon-product-technology.svg";
import GraphSoftware from "../../../assets/image/productTechnology/graph-software.svg";
import VideoHeader from "../../../assets/video/fabrication.mp4";
import Screenshot1 from "../../../assets/image/productTechnology/software/screenshot-1.jpeg";
import Screenshot2 from "../../../assets/image/productTechnology/software/screenshot-2.jpeg";
import Screenshot3 from "../../../assets/image/productTechnology/software/screenshot-3.jpeg";
import { useTranslate } from "addeus-common-library/stores/translate";
import ImageHeader from "../../../components/website/ImageHeader.vue";
import Footer from "../../../components/website/Footer.vue";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import { useSeoMeta } from "../../../composables/useSeoMeta";

useSeoMeta({
    title: "Track2Max - Logiciel de gestion de karting",
    description:
        "Track2Max : logiciel de gestion pour pistes de karting. Caisse NF525, réservation en ligne, chronométrage, planning et gestion du parc kart.",
    path: "/product-technology/software",
    breadcrumbs: [
        { name: "Accueil", path: "/" },
        { name: "Produits & Technologies", path: "/product-technology/karting" },
        { name: "Logiciel Track2Max", path: "/product-technology/software" },
    ],
    schemaOrg: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        name: "Track2Max",
        description:
            "Logiciel de gestion pour pistes de karting : caisse NF525, réservation en ligne, chronométrage et planning.",
        url: "https://speed2max.com/product-technology/software",
        applicationCategory: "BusinessApplication",
        operatingSystem: "Web",
        author: {
            "@type": "Organization",
            name: "Speed2Max",
            url: "https://speed2max.com",
        },
    },
});

const breakpoints = useBreakpoints(breakpointsTailwind);
const smallerThanMd = breakpoints.smallerOrEqual("md");
const smallerThanXl = breakpoints.smallerOrEqual("xl");

const { setTranslateNamespace } = useTranslate();
setTranslateNamespace(".productTechnology.software");
</script>

<template>
    <VFlex flex-direction="column" class="has-background-dark">
        <ProductTechnologyNavigation current="software"></ProductTechnologyNavigation>
        <ImageHeader :hide-background="true">
            <template #image>
                <div :class="{ 'video-landing': !smallerThanXl }" style="display: flex">
                    <video
                        playsinline
                        loop
                        muted
                        autoplay
                        crossorigin="anonymous"
                        :class="{ 'mb-4': smallerThanXl }">
                        <source :src="VideoHeader" />
                    </video>
                </div>
            </template>

            <template #title>
                <div><Translate path=".title"></Translate></div>
                <div class="has-text-primary"><Translate path=".title2"></Translate></div>
            </template>
            <template #icon>
                <img :src="IconProductTechnologySoftware" alt="administration icon" />
            </template>
        </ImageHeader>
        <TranslateNamespace path=".content">
            <VFlex
                flex-direction="column"
                class="has-background-dark is-align-self-center p-6"
                align-items="center">
                <h3
                    class="has-text-white is-size-2 is-uppercase is-weight-700 mx-3 has-text-centered">
                    <Translate path=".title"></Translate>
                    <span class="has-text-primary">Track2max</span>
                </h3>
                <!--VPlyr
                    :source="VideoPresentation"
                    style="min-height: 250px"
                    class="has-border-radius mt-3"></VPlyr-->
                <p class="has-text-white is-size-5 has-text-centered m-5">
                    <Translate>.introduction</Translate>
                </p>
            </VFlex>
            <img
                class="has-background-white p-6"
                :src="GraphSoftware"
                alt="Innovation S2M" />
            <VFlex
                :flex-direction="smallerThanMd ? 'column' : isBetween ? 'column' : 'row'"
                row-gap="2rem"
                column-gap="2rem"
                class="px-6 py-5 has-background-white">
                <VFlex flex-direction="column" column-gap="2rem" row-gap="2rem">
                    <div>
                        <VFlex
                            flex-direction="row"
                            row-gap="1rem"
                            column-gap="1rem"
                            align-items="center">
                            <!-- eslint-disable-next-line vuejs-accessibility/heading-has-content -->
                            <h3
                                class="has-text-dark is-size-3 is-uppercase is-weight-700 has-text-primary">
                                <Translate path=".titleCheckout"></Translate>
                            </h3>
                        </VFlex>
                        <p class="is-size-5 has-text-dark is-weight-400 mt-3">
                            <Translate path=".contentCheckout"></Translate>
                        </p>
                    </div>
                    <div>
                        <VFlex
                            flex-direction="row"
                            row-gap="1rem"
                            column-gap="1rem"
                            align-items="center">
                            <!-- eslint-disable-next-line vuejs-accessibility/heading-has-content -->
                            <h3
                                class="has-text-dark is-size-3 is-uppercase is-weight-700 has-text-primary">
                                <Translate path=".titleOnlineCheckout"></Translate>
                            </h3>
                        </VFlex>
                        <p class="is-size-5 has-text-dark is-weight-400 mt-3">
                            <Translate path=".contentOnlineCheckout"></Translate>
                        </p>
                    </div>
                    <div>
                        <VFlex
                            flex-direction="row"
                            row-gap="1rem"
                            column-gap="1rem"
                            align-items="center">
                            <!-- eslint-disable-next-line vuejs-accessibility/heading-has-content -->
                            <h3
                                class="has-text-dark is-size-3 is-uppercase is-weight-700 has-text-secondary">
                                <Translate path=".titleFidelity"></Translate>
                            </h3>
                        </VFlex>
                        <p class="is-size-5 has-text-dark is-weight-400 mt-3">
                            <Translate path=".contentFidelity"></Translate>
                        </p>
                    </div>
                </VFlex>
                <VFlex flex-direction="column" column-gap="2rem" row-gap="2rem">
                    <div>
                        <VFlex
                            flex-direction="row"
                            row-gap="1rem"
                            column-gap="1rem"
                            align-items="center">
                            <!-- eslint-disable-next-line vuejs-accessibility/heading-has-content -->
                            <h3
                                class="has-text-dark is-size-3 is-uppercase is-weight-700 has-text-primary">
                                <Translate path=".titlePlanning"></Translate>
                            </h3>
                        </VFlex>
                        <p class="is-size-5 has-text-dark is-weight-400 mt-3">
                            <Translate path=".contentPlanning"></Translate>
                        </p>
                    </div>
                    <div>
                        <VFlex
                            flex-direction="row"
                            row-gap="1rem"
                            column-gap="1rem"
                            align-items="center">
                            <!-- eslint-disable-next-line vuejs-accessibility/heading-has-content -->
                            <h3
                                class="has-text-dark is-size-3 is-uppercase is-weight-700 has-text-secondary">
                                <Translate path=".titleKart"></Translate>
                            </h3>
                        </VFlex>
                        <p class="is-size-5 has-text-dark is-weight-400 mt-3">
                            <Translate path=".contentKart"></Translate>
                        </p>
                    </div>
                    <div>
                        <VFlex
                            flex-direction="row"
                            row-gap="1rem"
                            column-gap="1rem"
                            align-items="center">
                            <!-- eslint-disable-next-line vuejs-accessibility/heading-has-content -->
                            <h3
                                class="has-text-dark is-size-3 is-uppercase is-weight-700 has-text-secondary">
                                <Translate path=".titleTime"></Translate>
                            </h3>
                        </VFlex>
                        <p class="is-size-5 has-text-dark is-weight-400 mt-3">
                            <Translate path=".contentTime"></Translate>
                        </p>
                    </div>
                </VFlex>
            </VFlex>
            <VFlex
                flex-direction="row"
                class="has-background-white p-6 presentation-t2m"
                flex-wrap="wrap"
                row-gap="20px"
                column-gap="20px">
                <img :src="Screenshot1" alt="Screenshot T2M" />
                <img :src="Screenshot2" alt="Screenshot T2M" />
                <img :src="Screenshot3" alt="Screenshot T2M" />
            </VFlex>
        </TranslateNamespace>
        <Footer></Footer>
    </VFlex>
</template>

<style lang="scss">
.presentation-t2m {
    img {
        max-height: 350px;
    }
}

.video-landing {
    width: 100%;
    min-height: 100vh;
    object-fit: cover;
    pointer-events: none;
}

.image-header-image {
    align-content: center;

    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
}
</style>
